import script from "./support-contact-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./support-contact-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__